
export const GET_ROLE = `GET_ROLE`;
export const SET_ROLE = `SET_ROLE`;

export const GET_ACCESSDETAILS = `GET_ACCESSDETAILS`
export const SET_ACCESSDETAILS = `SET_ACCESSDETAILS`

export const GET_APIMKEY = `GET_APIMKEY`
export const SET_APIMKEY = `SET_APIMKEY`

export const GET_DETAILS = `GET_DETAILS`;
export const SET_DETAILS = `SET_DETAILS`;

export const GET_SOURCE = `GET_SOURCE`;
export const SET_SOURCE = `SET_SOURCE`;


export const GET_REASONCODE = `GET_REASONCODE`;
export const SET_REASONCODE = `SET_REASONCODE`;


export const GET_TEMPLATE = `GET_TEMPLATE`;
export const SET_TEMPLATE = `SET_TEMPLATE`;


export const GET_NOOFRECIPIENT = `GET_NOOFRECIPIENT`;
export const SET_NOOFRECIPIENT = `SET_NOOFRECIPIENT`;

export const GET_TEMPLATECONTENT = `GET_TEMPLATECONTENT`;
export const SET_TEMPLATECONTENT = `SET_TEMPLATECONTENT`;

export const GET_URGENCY = `GET_URGENCY`;
export const SET_URGENCY = `SET_URGENCY`;

export const GET_STATUSGRID = `GET_STATUSGRID`;
export const SET_STATUSGRID = `SET_STATUSGRID`;

export const GET_SAVEREQUEST = `GET_SAVEREQUEST`;
export const SET_SAVEREQUEST = `SET_SAVEREQUEST`;

export const GET_SAVETEMPLATE = `GET_SAVETEMPLATE`;
export const SET_SAVETEMPLATE = `SET_SAVETEMPLATE`;

export const GET_EDITTEMPLATE = `GET_EDITTEMPLATE`;
export const SET_EDITTEMPLATE = `SET_EDITTEMPLATE`;

export const GET_SENDFORAPPROVAL = `GET_SENDFORAPPROVAL`;
export const SET_SENDFORAPPROVAL = `SET_SENDFORAPPROVAL`;

export const GET_REQUESTDETAILS = `GET_REQUESTDETAILS`;
export const SET_REQUESTDETAILS = `SET_REQUESTDETAILS`;

export const GET_APPROVERSGRID = `GET_APPROVERSGRID`;
export const SET_APPROVERSGRID = `SET_APPROVERSGRID`;

export const GET_ASSIGNTOME = `GET_ASSIGNTOME`;
export const SET_ASSIGNTOME = `SET_ASSIGNTOME`;

export const GET_APPROVEORDECLINE = `GET_APPROVEORDECLINE`;
export const SET_APPROVEORDECLINE = `SET_APPROVEORDECLINE`;

export const GET_USETEMPLATECONTENT = `GET_USETEMPLATECONTENT`;
export const SET_USETEMPLATECONTENT = `SET_USETEMPLATECONTENT`;

export const SET_TEMPALTEDLLIST = `SET_TEMPALTEDLLIST`
export const GET_TEMPALTEDLLIST = `GET_TEMPALTEDLLIST`

export const GET_DELETE_REQUEST = `GET_DELETE_REQUEST`
export const SET_DELETE_REQUEST = `SET_DELETE_REQUEST`
export const SET_DELETE_TEMPLATE = `SET_DELETE_TEMPLATE`


export const DOWNLOAD_DL = `DOWNLOAD_DL`;
export const SAVE_DL = `SAVE_DL`;

export const SEND_MASS_EMAIL = `SEND_MASS_EMAIL`
export const SCHEDULE_MASS_EMAIL = `SCHEDULE_MASS_EMAIL`
export const CANCEL_REQUEST = `CANCEL_REQUEST`
export const SET_FILEUPLOADERRMSG = `SET_FILEUPLOADERRMSG`
export const SET_CANCEL_ERROR = `SET_CANCEL_ERROR`
export const SET_ACTIVE_STATUS = `SET_ACTIVE_STATUS`
export const SET_EDL_UPLOADED = `SET_EDL_UPLOADED`

export const setEdlUploadStatus = (data) => ({
    type: SET_EDL_UPLOADED,
    value: data
})


export const setActiveStatus = (data) => ({
    type: SET_ACTIVE_STATUS,
    value: data
})

export const setCancelledError = (type,msg) => ({
    type: SET_CANCEL_ERROR,
    status: type,
    msg:msg
})

export const getAPIMKey = () => ({
    type: GET_APIMKEY
})

export const setAPIMKey = (data) => ({
    type: SET_APIMKEY,
    value: data
})

export const getDetails = (role) => ({
    type: GET_DETAILS,
    payload: role
})

export const setDetails = (data) => ({
    type: SET_DETAILS,
    value: data
});

export const getAccessDetails = (userInfo) => ({
    type: GET_ACCESSDETAILS,
    value: userInfo
})

export const setAccessDetails = (data) => ({
    type: SET_ACCESSDETAILS,
    value: data
})

export const getRole = () => ({
    type: GET_ROLE
})

export const setRole = (data) => ({
    type: SET_ROLE,
    value: data
});

export const getSource = () => ({
    type: GET_SOURCE
})

export const setSource = (data) => ({
    type: SET_SOURCE,
    value: data
});

export const getReasonCode = () => ({
    type: GET_REASONCODE
})

export const setReasonCode = (data) => ({
    type: SET_REASONCODE,
    value: data
});

export const getTemplate = () => ({
    type: GET_TEMPLATE
})

export const setTemplate = (data) => ({
    type: SET_TEMPLATE,
    value: data
});

export const getNoOfRecipient = (file) => ({
    type: GET_NOOFRECIPIENT,
    value: file
})

export const setNoOfRecipient = (data) => ({
    type: SET_NOOFRECIPIENT,
    value: data
});

export const getUrgency = () => ({
    type: GET_URGENCY
})

export const setUrgency = (data) => ({
    type: SET_URGENCY,
    value: data
});

export const getStatusGrid = (data) => ({
    type: GET_STATUSGRID,
    value: data
})

export const setStatusGrid = (data) => ({
    type: SET_STATUSGRID,
    value: data
});

export const getTemplateContent = (data) => ({
    type: GET_TEMPLATECONTENT,
    value: data
})

export const setTemplateContent = (data) => ({
    type: SET_TEMPLATECONTENT,
    value: data
});

export const getSaveRequest = (data) => ({
    type: GET_SAVEREQUEST,
    value: data
})

export const setSaveRequest = (data) => ({
    type: SET_SAVEREQUEST,
    value: data
});

export const getEditTemplate = (data, tempId, tempName) => ({
    type: GET_EDITTEMPLATE,
    value: data,
    tempId: tempId,
    tempName: tempName
})

export const setEditTemplate = (data) => ({
    type: SET_EDITTEMPLATE,
    value: data
});

export const getSaveTemplate = (data) => ({
    type: GET_SAVETEMPLATE,
    value: data
})

export const setSaveTemplate = (data) => ({
    type: SET_SAVETEMPLATE,
    value: data
});

export const getSendForApproval = (data) => ({
    type: GET_SENDFORAPPROVAL,
    value: data
})

export const setSendForApproval = (data) => ({
    type: SET_SENDFORAPPROVAL,
    value: data
});


export const getRequestDetails = (data) => ({
    type: GET_REQUESTDETAILS,
    value: data
});

export const setRequestDetails = (data) => ({
    type: SET_REQUESTDETAILS,
    value: data
});

export const getApproversGrid = (data) => ({
    type: GET_APPROVERSGRID,
    value: data
});

export const getUseTemplateContent = (data) => ({
    type: GET_USETEMPLATECONTENT,
    value: data
})

export const setUseTemplateContent = (data) => ({
    type: SET_USETEMPLATECONTENT,
    value: data
});

export const downloadDl = () => ({
    type: DOWNLOAD_DL
});

export const getTemplateDlList = (searchObj, PageNo, RowCount, FieldName, SortBy) => ({
    type: GET_TEMPALTEDLLIST,
    value: searchObj,
    PageNo: PageNo,
    RowCount: RowCount,
    FieldName: FieldName,
    SortBy: SortBy,

})

export const setTemplateDlList = (data) => ({
    type: SET_TEMPALTEDLLIST,
    value: data
})

export const saveDl = (data) => ({
    type: SAVE_DL,
    payload: data
})

export const sendMassEmail = (data) => ({
    type: SEND_MASS_EMAIL,
    value: data
})

export const scheduleMassEmail = (data) => ({
    type: SCHEDULE_MASS_EMAIL,
    value: data
})

export const cancelRequest = (requestId, userId, name) => ({
    type: CANCEL_REQUEST,
    requestId: requestId,
    userId: userId,
    name: name,
})
export const getDeleteRequest = (requestId, userId, name) => ({
    type: GET_DELETE_REQUEST,
    templateId: requestId,
    userId: userId,
    name: name,
})
export const setDeleteRequest = (data) => ({
    type: SET_DELETE_REQUEST,
    value: data
})
export const setDeleteTemplate = (data) => ({
    type: SET_DELETE_TEMPLATE,
    value: data
})

export const setApproverGrid = (data) => ({
    type: SET_APPROVERSGRID,
    value: data
});

export const getAssignToMe = (data) => ({
    type: GET_ASSIGNTOME,
    value: data
});

export const setAssignToMe = (data) => ({
    type: SET_ASSIGNTOME,
    value: data
});

export const getApproveOrDecline = (data, reqId) => ({
    type: GET_APPROVEORDECLINE,
    value: data,
    reqId: reqId
});

export const setApproveOrDecline = (data) => ({
    type: SET_APPROVEORDECLINE,
    value: data
});

export const setFileUploadErrMsg = (data) => ({
    type: SET_FILEUPLOADERRMSG,
    value: data
});







